import { type ISbStoryData } from '@storyblok/react/rsc'

import { type StoryblokComponentType } from './model/storyblokComponents'

const isStoryblokBlock = (block: unknown): block is StoryblokComponentType =>
  Boolean(
    block &&
    typeof block === 'object' &&
    '_uid' in block &&
    'component' in block,
  )

export const walkStoryblokBlocks = <T = unknown>(
  /**
   * Provide blocks, not the story itself
   */
  input: T extends ISbStoryData ? never : T,
  callback: (component: StoryblokComponentType) => void,
): void => {
  if (Array.isArray(input)) {
    for (const item of input) {
      walkStoryblokBlocks(item, callback)
    }

    return
  }

  if (!isStoryblokBlock(input)) {
    return
  }

  callback(input)

  for (const item of Object.values(input)) {
    walkStoryblokBlocks(item, callback)
  }
}
